import Vue from 'vue'
import Router from 'vue-router'
import Post from '@/pages/Post'
import Topic from '@/pages/Topic'
import FeihuaTopics from '@/pages/FeihuaTopics'
import JielongTopics from '@/pages/JielongTopics'
import WechatLogIn from '@/pages/account/WechatLogIn'
import WeiboLogIn from '@/pages/account/WeiboLogIn'
import QQLogIn from '@/pages/account/QQLogIn'
import LogInSelection from '@/pages/account/LogInSelection'
import LogInByAccount from '@/pages/account/LogInByAccount'
import SignUp from '@/pages/account/SignUp'
import SignUpVerifyPhone from '@/pages/account/SignUpVerifyPhone'
import SignUpSetInfo from '@/pages/account/SignUpSetInfo'
import Quizs from '@/pages/quiz/Quizs'
import StartQuiz from '@/pages/quiz/StartQuiz'
import Quiz from '@/pages/quiz/Quiz'
import MyQuizResult from '@/pages/quiz/MyQuizResult'
import Work from '@/pages/library/Work'
import Author from '@/pages/library/Author'
import Collection from '@/pages/library/Collection'
import Library from '@/pages/Library'
import Search from '@/pages/Search'
import Home from '@/pages/Home'
import Game from '@/pages/Game'
import Lists from '@/pages/Lists'
import WorkLists from '@/pages/WorkLists'
import List from '@/pages/List'
import NavAuthor from '@/pages/NavAuthor'
import NavPoetry from '@/pages/NavPoetry'
import NavQuote from '@/pages/NavQuote'
import NavCipai from '@/pages/NavCipai'
import LibraryEdu from '@/pages/LibraryEdu'
import WorkPost from '@/pages/library/WorkPost'
import AuthorPost from '@/pages/library/AuthorPost'
import CollectionPost from '@/pages/library/CollectionPost'
import Test from '@/pages/Test.vue'
import XCTime from '@/pages/XCTime.vue'
import XCTimeAlbumList from '@/pages/XCTimeAlbumList.vue'
import XCTAlbum from '@/pages/XCTAlbum.vue'
import XCTMusic from '@/pages/XCTMusic.vue'
import CollectionKind from '@/pages/CollectionKind.vue'
import UserCenter from '@/pages/user-center/UserCenter.vue'
import UserMsg from '@/pages/user-msg/UserMsg.vue'
import UserPosts from '@/pages/user-msg/UserPosts.vue'
import LogInBySmsCode from '@/pages/account/LogInBySmsCode.vue'
import GetOpenId from '@/pages/account/GetOpenId.vue'
import { csuRouter, jmRouter, eduRouter, kenbenRouter } from './layout-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/post/:id',
    name: 'post',
    component: Post,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/list/:id',
    name: 'list',
    component: List,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/work/:id/lists',
    name: 'workLists',
    component: WorkLists,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/topic/:id',
    name: 'topic',
    component: Topic,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/library',
    name: 'library',
    component: Library,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/lists',
    name: 'lists',
    component: Lists,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/discover',
    name: 'game',
    component: Game,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/feihuas',
    name: 'feihuas',
    component: FeihuaTopics,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/jielongs',
    name: 'jielongs',
    component: JielongTopics,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/quiz/:id',
    name: 'quiz',
    component: Quiz,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/quizs',
    name: 'quizs',
    component: Quizs,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/start-quiz/:id',
    name: 'startQuiz',
    component: StartQuiz,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/my-quiz-result/:id',
    name: 'myQuizResult',
    component: MyQuizResult,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/work/:id',
    name: 'work',
    component: Work,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/author/:id',
    name: 'author',
    component: Author,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/collection/:id',
    name: 'collection',
    component: Collection,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/wechat-login',
    name: 'wechatLogIn',
    component: WechatLogIn,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/qq-login',
    name: 'qqLogIn',
    component: QQLogIn,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/login-selection',
    name: 'logInSelection',
    component: LogInSelection,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/login-by-account',
    name: 'logInByAccount',
    component: LogInByAccount,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/login-by-sms-code',
    name: 'logInBySmsCode',
    component: LogInBySmsCode,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/signup',
    name: 'signUp',
    component: SignUp,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/signup-verify-phone',
    name: 'signUpVerifyPhone',
    component: SignUpVerifyPhone,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/signup-set-info',
    name: 'signUpSetInfo',
    component: SignUpSetInfo,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/weibo-login',
    name: 'weiboLogIn',
    component: WeiboLogIn,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/nav-author',
    name: 'navAuthor',
    component: NavAuthor,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/nav-poetry',
    name: 'navPoetry',
    component: NavPoetry,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/nav-quote',
    name: 'navQuote',
    component: NavQuote,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/nav-cipai',
    name: 'navCipai',
    component: NavCipai,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  {
    path: '/edu',
    name: 'libraryEdu',
    component: LibraryEdu,
    meta: {
      keepAlive: true // 需要缓存
    }
  },
  // {
  //   path: '/work/post/:workId',
  //   name: 'workPost',
  //   component: WorkPost,
  //   meta: {
  //     keepAlive: false // 不需要缓存
  //   }
  // },
  {
    path: '/author/post/:authorId',
    name: 'authorPost',
    component: AuthorPost,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/collection/post/:collectionId',
    name: 'collectionPost',
    component: CollectionPost,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/test',
    name: 'test',
    component: Test,
    meta: {
      keepAlive: false // 不需要缓存
    }
  },
  {
    path: '/time', // 原path: /xct
    name: 'xcTime',
    component: XCTime,  // 需要缓存
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/xct-albums/:tagId',
    name: 'xctAlbums',
    component: XCTimeAlbumList,
    meta: {
      keepAlive: false
    }
  },
  // {
  //   path: '/xct-album/:albumId',
  //   name: 'xctAlbum',
  //   component: XCTAlbum,
  //   meta: {
  //     keepAlive: false
  //   }
  // },
  {
    path: '/collection-kind/:id',
    name: 'collectionKind',
    component: CollectionKind,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/xct-music/:albumId/:trackId',
    name: 'xctMusic',
    component: XCTMusic,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user-center',  // 暂时没有做用户中心
    name: 'userCenter',
    component: UserCenter,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user-msg/:userId',    // 其他用户的信息
    name: 'userMsg',
    component: UserMsg,
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/user-posts/:userId/:channelId',
    name: 'userPosts',
    component: UserPosts,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/get-open-id',
    name: 'getOpenId',
    component: GetOpenId
  }
].concat(csuRouter, jmRouter, eduRouter, kenbenRouter)


let router = new Router({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  // 统计代码
  if (to.path) {
    console.log(_hmt)
    // _hmt.push(['_trackPageview', '/#' + to.fullPath])
    _hmt.push(['_trackPageview', to.fullPath])
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js